// Desc: Home page component
import { SearchBox } from "_components";
import { formatCurrency } from "_lib/utils";
import { ConfigurationAtom, DestinationAtom } from "_states";
import { Link } from "react-router-dom";
import { useRecoilValue } from "recoil";

/**
 * DestinationsPage component
 * @returns {JSX.Element} JSX.Element
 */
const DestinationsPage = () => {
  const destinations = useRecoilValue(DestinationAtom);
  const configurations = useRecoilValue(ConfigurationAtom);

  const tours = [1, 2, 3, 4, 5, 6, 7, 8];

  return (
    <>
      <div
        className="flex flex-col items-center justify-center h-[500px] bg-center bg-cover bg-no-repeat w-full text-white lg:space-y-6 space-y-4 text-center"
        style={{ backgroundImage: "url('/images/destinations-banner.jpg')" }}
      >
        <h1 className="md:text-5xl text-2xl px-2 pb-12">Top destinations</h1>

        <SearchBox />
      </div>

      {/* Top Destinations section */}
      <section className="max-w-7xl mx-auto space-y-8 pb-36 md:px-2 sm:px-4 px-4">
        <div>
          <h2 className="font-semibold md:text-4xl text-2xl text-center my-10">
            {destinations.length} destinations found
          </h2>
          <div className="grid lg:grid-cols-4 sm:grid-cols-2 grid-cols-1 gap-6">
            {destinations.map((destination, index) => (
              <Link
                key={index}
                to={`/tours/${destination.slug}`}
                className="relative flex justify-start items-end rounded-lg overflow-hidden h-[420px]"
              >
                <div
                  className="h-full w-full transition ease-in-out duration-500 hover:scale-110 bg-center bg-cover hover:brightness-50"
                  style={{
                    backgroundImage: `url(\'${destination.image}\')`,
                  }}
                ></div>
                <div className="absolute w-full text-white bg-black bg-opacity-50 pointer-events-none p-4">
                  <h3 className="text-2xl font-bold">{destination.name}</h3>
                  <p>
                    Starts from{" "}
                    <span className="font-bold">
                      {formatCurrency(destination.starting_price)}
                    </span>{" "}
                    per PAX
                  </p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Popular tours section */}
      <section className="max-w-7xl mx-auto space-y-8 pb-24 md:px-2 sm:px-4 px-4">
        <h2 className="font-semibold text-4xl text-center mb-10">
          Our popular tours
        </h2>
        <div className="grid md:grid-cols-4 sm:grid-cols-2 gap-6">
          {configurations.featured_tours.slice(0, 8).map((tour) => (
            <Link
              key={tour.id}
              to={`/itinerary/${tour.id}`}
              className="bg-white border transition ease-in-out duration-200 hover:shadow-lg hover:scale-105 rounded-lg overflow-hidden"
            >
              <img
                src={tour.image ? tour.image : "/images/tour.png"}
                alt="tour"
                className="w-full h-52 object-cover object-center"
              />
              <div className="p-4 space-y-2">
                <h3 className="text-xl font-semibold">{tour.name}</h3>
                <p className="text-sm">
                  {tour.nights + 1} days {tour.nights} nights
                </p>
                <p className="text-sm">
                  Starting from{" "}
                  <strong>{formatCurrency(tour.starting_price)}</strong> pax
                </p>
              </div>
            </Link>
          ))}
        </div>
        <div className="text-center">
          <Link
            to="/tours"
            className="bg-primary text-white font-medium px-8 py-3 rounded-lg"
          >
            View all tours
          </Link>
        </div>
      </section>
    </>
  );
};

export default DestinationsPage;
